module.exports = __webpack_public_path__ + "clicks-es2015.worker.js"